var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2899 0.883545H4.69991C3.88792 0.883545 3.22729 1.54418 3.22729 2.35616V2.5369H2.25332C1.44133 2.5369 0.780701 3.19753 0.780701 4.00951V12.7165C0.780701 13.5285 1.44133 14.1891 2.25332 14.1891H7.84329C8.65527 14.1891 9.31584 13.5285 9.31584 12.7165V12.5358H10.2898C11.1018 12.5358 11.7624 11.8752 11.7624 11.0632V2.35616C11.7625 1.54418 11.1019 0.883545 10.2899 0.883545ZM8.36599 12.7165C8.36599 13.0047 8.13149 13.2392 7.84335 13.2392H2.25332C1.96511 13.2392 1.73061 13.0047 1.73061 12.7165V4.00945C1.73061 3.72124 1.96511 3.48674 2.25332 3.48674H7.84329C8.13149 3.48674 8.36593 3.72124 8.36593 4.00945V12.7165H8.36599ZM10.8126 11.0632C10.8126 11.3514 10.5781 11.5859 10.2899 11.5859H9.3159V4.00945C9.3159 3.19746 8.65527 2.53683 7.84335 2.53683H4.1772V2.3561C4.1772 2.06789 4.4117 1.83339 4.69991 1.83339H10.2899C10.5781 1.83339 10.8126 2.06789 10.8126 2.3561V11.0632Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhite);
export default __webpack_public_path__ + "static/media/copy-white.4dab76f430dd3091d54e4d32e139e686.svg";
export { ForwardRef as ReactComponent };